import { GET_FUNDS, GET_FUND_DETAIL } from "./constants";

export function getFundDetails(id) {
  return {
    type: GET_FUND_DETAIL,
    id,
  };
}

export function getFunds() {
  return {
    type: GET_FUNDS,
  };
}